import { MessageFilled } from "@ant-design/icons";
import { FC, useCallback } from "react";
import {
    Product,
    PromoTagProduct,
    TaskPhotosEntity,
    TaskStatus,
} from "tm-shared/types";
import { formatUAHNumber } from "tm-shared/utils";

import { StatusCycleButton } from "@/components/CycleButton";
import FlexContainer from "@/components/FlexContainer";
import { StatusIndicator } from "@/components/Status/StatusIndicator";
import { PrimaryText } from "@/components/Typography/Styled";

import {
    StyledCommentIndicator,
    StyledPriceText,
    StyledTaskPromoTag,
} from "./Styled";

interface TaskPromoTagProps {
    product: PromoTagProduct;
    catalogProduct: Product;
    isActive: boolean;
    onChangeActive: (id: string) => void;
    payload: TaskPhotosEntity | undefined;
    onChangeTaskStatus: (status: TaskStatus, barcode?: string) => void;
}

export const TaskPromoTag: FC<TaskPromoTagProps> = ({
    product,
    isActive,
    onChangeActive,
    payload,
    catalogProduct,
    onChangeTaskStatus,
}) => {
    const { barcode, price } = product;

    const hasComment = !!payload?.comment;
    const status = payload?.status ?? TaskStatus.Incomplete;
    const photoCount = payload?.photos?.length ?? 0;

    const selectTask = useCallback(() => {
        onChangeActive(barcode);
    }, [barcode]);

    const handleChangeTaskStatus = useCallback(
        (status: TaskStatus) => {
            onChangeTaskStatus(status, barcode);
        },
        [barcode],
    );

    return (
        <StyledTaskPromoTag $isActive={isActive} onClick={selectTask}>
            <div>
                <PrimaryText>
                    {catalogProduct?.name} ({product.barcode})
                </PrimaryText>
                <PrimaryText>
                    <StyledPriceText>Акційна ціна:</StyledPriceText>{" "}
                    {formatUAHNumber(+price)}
                </PrimaryText>
            </div>

            <FlexContainer>
                <StyledCommentIndicator>
                    {hasComment && (
                        <StatusIndicator type="warning">
                            <MessageFilled />
                        </StatusIndicator>
                    )}
                </StyledCommentIndicator>

                <StatusCycleButton
                    value={status}
                    onChange={handleChangeTaskStatus}
                    states={[TaskStatus.Incomplete, TaskStatus.Rejected]}
                    disabled={status === TaskStatus.Completed}
                    photoMode
                    photoCount={photoCount}
                    dimension={48}
                    border={false}
                />
            </FlexContainer>
        </StyledTaskPromoTag>
    );
};
